/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetConnectWifiIcon16Light = forwardRef('NetConnectWifiIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8.001 4a8 8 0 0 0-5.98 2.685.5.5 0 0 1-.748-.664 9 9 0 0 1 13.456.002.5.5 0 0 1-.747.665A8 8 0 0 0 8.002 4Z" }),
        React.createElement("path", { d: "M8.004 8a4 4 0 0 0-3.13 1.505.5.5 0 1 1-.782-.624 5 5 0 0 1 7.822.007.5.5 0 0 1-.783.623A4 4 0 0 0 8.004 8Z" }),
        React.createElement("path", { d: "M8 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" })));
});
